import { Component, inject, OnDestroy } from "@angular/core";
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { StandardImageComponent } from "@components/standard-image/standard-image.component";
import { ProjectImageService } from "@domain/project/project-image.service";
import { TranslateProjectImageTagPipe } from "@domain/project/translate-project-image-tag.pipe";
import { UserService } from "@domain/user/user.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { AutocompleteSearchFilterPipe } from "@odx/angular/components/autocomplete";
import { Modal, ModalRef } from "@odx/angular/components/modal";
import { map, Observable } from "rxjs";

interface ImageUploadModalData {
  imageUrl: string;
  name: string;
}

interface ImageUploadModalResult {
  imageUrl: string;
  name: string;
  description: string;
  tags: string[] | null;
}

@Component({
  selector: "app-image-upload-modal",
  templateUrl: "./image-upload-modal.component.html",
  styleUrl: "./image-upload-modal.component.scss",
  imports: [UiKitModule, ReactiveFormsModule, StandardImageComponent, TranslateProjectImageTagPipe, AutocompleteSearchFilterPipe],
})
export class ImageUploadModalComponent implements Modal<ImageUploadModalData, ImageUploadModalData>, OnDestroy {
  public readonly modalRef = inject(ModalRef<ImageUploadModalData, ImageUploadModalResult>);
  private readonly formBuilder = inject(FormBuilder);
  private projectImageService = inject(ProjectImageService);
  private userService = inject(UserService);

  protected readonly tooltipTextUploadImage: string = $localize`:@@floorplan.button.uploadImage:Foto hochladen`;
  protected readonly tooltipTextTakeImage: string = $localize`:@@floorplan.button.takeImage:Foto aufnehmen`;

  protected tagList$: Observable<string[]>;
  protected isMonitoringScope$: Observable<boolean>;
  protected isFgdsScope$: Observable<boolean>;
  protected readonly isProjectPhotosMobileModal = this.modalRef.id === "project-photos-upload-modal";

  imageUploadForm = this.formBuilder.group({
    name: new FormControl(this.modalRef.data.name, Validators.required),
    description: new FormControl(""),
    imageUrl: new FormControl<string | null>(this.modalRef.data.imageUrl, Validators.required),
    tags: new FormControl<string[] | null>(null),
  });

  constructor() {
    this.tagList$ = this.projectImageService.getProjectImageTags(BusinessScope.MONITORING);
    this.isMonitoringScope$ = this.userService.businessScope$.pipe(map((scope) => scope === BusinessScope.MONITORING));
    this.isFgdsScope$ = this.userService.businessScope$.pipe(map((scope) => scope === BusinessScope.FGDS));
  }

  ngOnDestroy() {
    URL.revokeObjectURL(this.modalRef.data.imageUrl);
  }

  onSubmit() {
    if (this.imageUploadForm.valid) {
      this.modalRef.close(this.imageUploadForm.value as ImageUploadModalResult);
    }
  }
}
